import React, { useState } from 'react';
import { Row } from './Layout';
import { useAuth } from '../hooks/useAuth';

interface DrawerProps {
    open: boolean;
    onClose: () => void;
    navigate: (page: string) => void;
}

const DRAWER_ITEMS = [
    { icon: "⭐", label: "Premium Ol", sub: "Sınırsız özellikler", color: "#FFD166", special: true, nav: "coins" },
    { icon: "💰", label: "Elmas Satın Al", sub: "Hediye gönder", color: "#00E5CC", nav: "coins" },
    { icon: "📊", label: "Yayın İstatistikleri", sub: "Analizlerin", color: "#A855F7", nav: "stats" },
    { icon: "🏆", label: "Liderlik Tablosu", sub: "En iyi yayıncılar", color: "#FF8A3D", nav: "leaderboard" },
    { icon: "🎯", label: "Görevler", sub: "3 aktif görev", color: "#22C55E", nav: "tasks" },
    { icon: "👥", label: "Arkadaşlarını Davet Et", sub: "Bonus kazan", color: "#3B82F6", nav: "invite" },
    { icon: "❓", label: "Yardım & Destek", sub: null, color: "var(--muted)", nav: "support" },
    { icon: "⚙️", label: "Ayarlar", sub: null, color: "var(--muted)", nav: "account" },
];

export const Drawer: React.FC<DrawerProps> = ({ open, onClose, navigate }) => {
    const [closing, setClosing] = useState(false);
    const { user, logout } = useAuth();

    const close = () => {
        setClosing(true);
        setTimeout(() => { setClosing(false); onClose(); }, 280);
    };

    if (!open && !closing) return null;

    return (
        <div style={{ position: 'absolute', inset: 0, zIndex: 200 }}>
            {/* Overlay */}
            <div onClick={close} style={{
                position: 'absolute', inset: 0,
                background: 'rgba(0,0,0,0.65)',
                backdropFilter: 'blur(4px)',
                animation: closing ? 'overlayIn .28s ease reverse' : 'overlayIn .28s ease',
            }} />
            {/* Panel */}
            <div style={{
                position: 'absolute', top: 0, left: 0, bottom: 0, width: '78%',
                background: 'linear-gradient(160deg,#12121c,#0e0e18)',
                borderRight: '1px solid var(--border)',
                animation: closing ? 'drawerIn .28s cubic-bezier(.4,0,.2,1) reverse' : 'drawerIn .32s cubic-bezier(.16,1,.3,1)',
                display: 'flex', flexDirection: 'column', overflow: 'hidden',
            }}>
                {/* Glow top */}
                <div style={{
                    position: 'absolute', top: -60, left: -40, width: 220, height: 220, borderRadius: '50%',
                    background: 'radial-gradient(circle,rgba(255,92,92,.12) 0%,transparent 70%)',
                    filter: 'blur(30px)', pointerEvents: 'none'
                }} />
                <div style={{
                    position: 'absolute', bottom: -40, right: -20, width: 180, height: 180, borderRadius: '50%',
                    background: 'radial-gradient(circle,rgba(0,229,204,.08) 0%,transparent 70%)',
                    filter: 'blur(30px)', pointerEvents: 'none'
                }} />

                {/* Header */}
                <div style={{ padding: '52px 20px 20px', flexShrink: 0 }}>
                    <Row style={{ justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                        <div className="syne" style={{ fontSize: 18, fontWeight: 800, letterSpacing: '-.01em' }}>
                            buddy<span style={{ color: 'var(--coral)' }}>live</span>
                        </div>
                        <button onClick={close} className="icon-btn" style={{ borderRadius: '50%', fontSize: 16 }}>✕</button>
                    </Row>
                    {/* User card */}
                    <div style={{
                        background: 'rgba(255,255,255,.04)', border: '1px solid var(--border)',
                        borderRadius: 18, padding: '14px', display: 'flex', gap: 12, alignItems: 'center', cursor: 'pointer'
                    }}
                        onClick={() => { close(); setTimeout(() => navigate('profile'), 300); }}>
                        <div style={{
                            width: 48, height: 48, borderRadius: 15,
                            background: 'linear-gradient(135deg,var(--coral),var(--purple))',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, flexShrink: 0
                        }}>😊</div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <div className="syne" style={{ fontSize: 14, fontWeight: 700 }}>{user?.username || 'Misafir'}</div>
                            <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 1 }}>@{user?.username || 'misafir'} · {user?.followers ?? 0} takipçi</div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                            <div style={{ width: 6, height: 6, background: 'var(--green)', borderRadius: '50%' }} />
                            <span style={{ fontSize: 9, color: 'var(--green)' }}>çevrimiçi</span>
                        </div>
                    </div>
                </div>

                {/* Quick stats */}
                <div style={{ padding: '0 20px 16px', flexShrink: 0 }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8 }}>
                        {[
                            { label: 'Elmas', val: user?.coins || 0, icon: '💎', color: 'var(--cyan)' },
                            { label: 'Yayın', val: user?.streams ?? 0, icon: '🎬', color: 'var(--coral)' },
                            { label: 'Rozet', val: 0, icon: '🏆', color: 'var(--gold)' },
                        ].map((s, i) => (
                            <div key={i} style={{
                                background: 'rgba(255,255,255,.04)', borderRadius: 12,
                                border: '1px solid var(--border)', padding: '10px 8px', textAlign: 'center'
                            }}>
                                <div style={{ fontSize: 18, marginBottom: 3 }}>{s.icon}</div>
                                <div className="syne" style={{ fontSize: 14, fontWeight: 800, color: s.color }}>{s.val}</div>
                                <div style={{ fontSize: 9, color: 'var(--muted)', marginTop: 1 }}>{s.label}</div>
                            </div>
                        ))}
                    </div>
                </div>

                <div style={{ width: 'calc(100% - 40px)', height: '1px', background: 'var(--border)', margin: '0 20px 12px' }} />

                {/* Nav items */}
                <div style={{ flex: 1, overflowY: 'auto', padding: '0 12px 20px' }}>
                    {DRAWER_ITEMS.map((item, i) => (
                        <div key={i} onClick={() => {
                            if (['coins', 'account', 'stats', 'leaderboard', 'tasks', 'invite', 'support'].includes(item.nav as string)) {
                                close(); setTimeout(() => navigate(item.nav as string), 300);
                            } else if (item.nav) {
                                alert('Bu özellik çok yakında eklenecektir!');
                            }
                        }}
                            style={{
                                display: 'flex', gap: 12, alignItems: 'center', padding: '11px 10px',
                                borderRadius: 14, cursor: 'pointer', marginBottom: 2,
                                background: item.special ? 'linear-gradient(135deg,rgba(255,209,102,.1),rgba(255,138,61,.08))' : 'transparent',
                                border: item.special ? '1px solid rgba(255,209,102,.2)' : '1px solid transparent',
                                transition: 'all .2s'
                            }}
                            onMouseEnter={e => !item.special && (e.currentTarget.style.background = 'rgba(255,255,255,.05)')}
                            onMouseLeave={e => !item.special && (e.currentTarget.style.background = 'transparent')}>
                            <div style={{
                                width: 38, height: 38, borderRadius: 12,
                                background: `${item.color}22`, border: `1px solid ${item.color}33`,
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: 18, flexShrink: 0
                            }}>
                                {item.icon}
                            </div>
                            <div style={{ flex: 1 }}>
                                <div style={{
                                    fontSize: 13, fontWeight: item.special ? 700 : 500,
                                    color: item.special ? 'var(--gold)' : 'var(--text)'
                                }}>{item.label}</div>
                                {item.sub && <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 1 }}>{item.sub}</div>}
                            </div>
                            {item.special && <div style={{
                                fontSize: 10, background: 'rgba(255,209,102,.2)', color: 'var(--gold)',
                                padding: '3px 8px', borderRadius: 6, fontFamily: 'Syne', fontWeight: 700
                            }}>YENİ</div>}
                        </div>
                    ))}
                </div>

                {/* Bottom logout */}
                <div style={{ padding: '12px 20px 32px', borderTop: '1px solid var(--border)', flexShrink: 0 }}>
                    <button onClick={() => {
                        if (window.confirm("Çıkış yapmak istediğinize emin misiniz?")) {
                            logout();
                            window.location.reload();
                        }
                    }} style={{
                        width: '100%', background: 'rgba(255,60,60,.08)', border: '1px solid rgba(255,60,60,.15)',
                        borderRadius: 12, padding: '12px', color: '#FF5555', fontSize: 13, cursor: 'pointer',
                        fontFamily: 'Syne', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8
                    }}>
                        🚪 Çıkış Yap
                    </button>
                </div>
            </div>
        </div>
    );
};
